export enum ContractStatusEnum {
  PENDING = 'PENDING',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  SIGNED = 'SIGNED',
}
